import { createSelector } from 'reselect';
import { STATE_NAME } from './constants';

const getTransactionState = (state) => state[STATE_NAME];

const getTransactionField = (field) =>
  createSelector(getTransactionState, (state) => state.get(field));

export const selectTransactionQuery = createSelector(
  getTransactionField('filters'),
  (state) => state.toJS()
);
